/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { AngularFireAction, DatabaseSnapshot } from '@angular/fire/compat/database';
import firebase from 'firebase/compat/app';

import { TicketList } from './TicketList';
import { PullColumnList } from './PullColumns';
import { CalendarWorkdays } from '@touchplan/ticket';
import { RefOrObservable } from '../../fancy-firebase/base/interfaces';
import { Observable, groupBy, mergeMap, withLatestFrom, from, EMPTY } from 'rxjs';
import {
	FancySupplementalAction,
	SupplementalActionTypes,
} from 'src/app/app-data/actions/supplemental-actions';
import { FancyTicketAction, TicketActionTypes } from 'src/app/app-data/actions/ticket-actions';

export class ConstraintList extends TicketList {
	public projectRef: firebase.database.Reference;

	constructor(
		protected angularLand,
		path: RefOrObservable,
		fancyJoins,
		protected workdays: CalendarWorkdays,
		protected pullColumnList: PullColumnList
	) {
		super(angularLand, path, fancyJoins, workdays);
		this.suppressActionsForLoading = false;
	}

	public $$added(action: AngularFireAction<DatabaseSnapshot<any>>) {
		const ticket = super.$$added(action);
		// ticket.isTimelineTicket = true;
		// ticket.pullColumnList = this.pullColumnList;
		// if(this.pullColumnList){
		// 	ticket.timelineX = this.pullColumnList.getXFromDate(ticket.view.liveFinish);
		// }
		ticket.timelineTicketSplitId = this.splitId(action.key);
		if (this.currentPlanArchive.has(ticket.timelineTicketSplitId[0])) {
			ticket.view.isPlanArchived = this.currentPlanArchive.get(ticket.timelineTicketSplitId[0]);
		}
		return ticket;
	}

	public handleSupplementalEvents(
		baseObservable: Observable<FancySupplementalAction>
	): Observable<FancyTicketAction> {
		return baseObservable.pipe(
			groupBy((action) => action.type),
			mergeMap((ob$) => {
				switch (ob$.key) {
					case SupplementalActionTypes.planArchivedChanged:
						return ob$.pipe(
							withLatestFrom(this.list$),
							mergeMap(([action, tickets]) => {
								const planArchived: Map<string, boolean> = action.payload;

								this.currentPlanArchive = new Map(planArchived);

								const emits = [];
								tickets.forEach((ticket) => {
									if (this.currentPlanArchive.has(ticket.timelineTicketSplitId[0])) {
										ticket.view.isPlanArchived = planArchived.get(ticket.timelineTicketSplitId[0]);
										emits.push(new FancyTicketAction(ticket, TicketActionTypes.ticketPlanDataUpdated));
									}
								});
								return from(emits);
							})
						);
					default:
						return EMPTY;
				}
			})
		);
	}

	protected getTicketRef(ticketId) {
		const splitId = this.splitId(ticketId);
		return this.projectRef.child(splitId[0]).child(splitId[1]);
	}

	private splitId(combinedId: string) {
		return combinedId.split(',') as [string, string];
	}

	// destroy(){
	// 	this.workdays = null;
	// 	this.pullColumnList = null;
	// 	super.destroy();
	// }
}
